import loadable from '@loadable/component';

// 懒加载组件
const CstStatementManagement = loadable(() => import('./cstStatementManagement/CstStatementManagement'));
const CstStatementModify = loadable(() => import('./cstStatementManagement/cstStatementModify/CstStatementModify'));
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));

export default [
  {
    path: '/CstStatementManagement',
    component: CstStatementManagement
  },
  {
    path: '/CstStatementModify',
    component: CstStatementModify
  },
  {
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  }
];
